import { Component, Input, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-continuous-loading-bar',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './continuous-loading-bar.component.html'
})
export class ContinuousLoadingBarComponent {
  @Input() dataToDisplay?: string; 
}
